let TaskData = {
    "code": 1,
    "msg": null,
    "data": [
        {
            "id": 645,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "细精修",
            "createTime": "2021-02-23 16:46:39",
            "updateTime": "2021-02-23 16:46:39",
            "status": "正在进行",
            "title": "电脑屏幕护眼灯",
            "chuliId": 4,
            "fabuId": 53,
            "kaifaId": null,
            "wangpan": "需求已对应发到美工",
            "yujikaishi": "2021-03-04 09:30:00",
            "yujihaoshi": 30.0,
            "shijihaoshi": null,
            "miaoShu": "<p>需求已对应发到美工</p>",
            "jieZhi": "2021-03-09 09:30:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "紧急插队",
            "countImg": null,
            "fabu": { "img": "/upload/904e6e2081664519b19bfa93e9fde4a5.jpg", "name": "李小艳", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        }
        , {
            "id": 553,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "细精修",
            "createTime": "2021-01-12 18:15:41",
            "updateTime": "2021-01-12 18:15:41",
            "status": "正在进行",
            "title": "电脑增高桌-图片需求",
            "chuliId": 4,
            "fabuId": 16,
            "kaifaId": 95,
            "wangpan": "1",
            "yujikaishi": "2021-03-05 11:00:00",
            "yujihaoshi": 30.0,
            "shijihaoshi": null,
            "miaoShu": "<p>1</p>",
            "jieZhi": "2021-03-10 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/f03d2c95a1e3487b89f991ee8fd82c73.jpg", "name": "黄导", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": { "img": "/upload/5065e2109ed547ecbdc286a663880c73.jpg", "name": "罗开坤", "bumen": "产品部", "groups": null }
        },
        {
            "id": 571,
            "leixing": "亚马逊 7张主图",
            "imgLeixing": "精修",
            "createTime": "2021-01-20 17:17:57",
            "updateTime": "2021-01-20 17:17:57",
            "status": "正在进行",
            "title": "园艺花盆图片需求",
            "chuliId": 4,
            "fabuId": 29,
            "kaifaId": 110,
            "wangpan": "1",
            "yujikaishi": "2021-03-10 11:00:00",
            "yujihaoshi": 15.0,
            "shijihaoshi": null,
            "miaoShu": "<p>详见表格<br></p>",
            "jieZhi": "2021-03-12 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/1940a1c4ca0b463c8a626ff7842a1eac.jpg", "name": "姚田", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": { "img": "/upload/22c110383bdf44e181252832d4ad9f08.jpg", "name": "徐军", "bumen": "产品部", "groups": null }
        }, {
            "id": 573,
            "leixing": "自定义",
            "imgLeixing": "精修",
            "createTime": "2021-01-21 16:12:05",
            "updateTime": "2021-01-21 16:12:05",
            "status": "正在进行",
            "title": "喂鸟器图片和A+需求",
            "chuliId": 4,
            "fabuId": 29,
            "kaifaId": 95,
            "wangpan": "1",
            "yujikaishi": "2021-03-12 11:00:00",
            "yujihaoshi": 15.0,
            "shijihaoshi": null,
            "miaoShu": "<p>详见表格<br></p>",
            "jieZhi": "2021-03-16 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/1940a1c4ca0b463c8a626ff7842a1eac.jpg", "name": "姚田", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": { "img": "/upload/5065e2109ed547ecbdc286a663880c73.jpg", "name": "罗开坤", "bumen": "产品部", "groups": null }
        }, {
            "id": 577,
            "leixing": "自定义",
            "imgLeixing": "精修",
            "createTime": "2021-01-22 15:45:07",
            "updateTime": "2021-01-22 15:45:07",
            "status": "正在进行",
            "title": "园艺花盆A+需求",
            "chuliId": 4,
            "fabuId": 29,
            "kaifaId": 110,
            "wangpan": "1",
            "yujikaishi": "2021-03-16 11:00:00",
            "yujihaoshi": 15.0,
            "shijihaoshi": null,
            "miaoShu": "<p>详见表格<br></p>",
            "jieZhi": "2021-03-18 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/1940a1c4ca0b463c8a626ff7842a1eac.jpg", "name": "姚田", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": { "img": "/upload/22c110383bdf44e181252832d4ad9f08.jpg", "name": "徐军", "bumen": "产品部", "groups": null }
        }, {
            "id": 584,
            "leixing": "自定义",
            "imgLeixing": "精修",
            "createTime": "2021-01-25 16:00:35",
            "updateTime": "2021-01-25 16:00:35",
            "status": "正在进行",
            "title": "儿童咬胶蛋图片需求",
            "chuliId": 4,
            "fabuId": 42,
            "kaifaId": 95,
            "wangpan": "1",
            "yujikaishi": "2021-03-18 11:00:00",
            "yujihaoshi": 15.0,
            "shijihaoshi": null,
            "miaoShu": "<p>1</p>",
            "jieZhi": "2021-03-20 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/04053c0e17a541ac93c4f4fe3e5fe3a4.jpg", "name": "黄玮", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": { "img": "/upload/5065e2109ed547ecbdc286a663880c73.jpg", "name": "罗开坤", "bumen": "产品部", "groups": null }
        }, {
            "id": 586,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "精修",
            "createTime": "2021-01-25 16:30:07",
            "updateTime": "2021-01-25 16:30:07",
            "status": "正在进行",
            "title": "打蒜A+",
            "chuliId": 4,
            "fabuId": 55,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-03-20 11:00:00",
            "yujihaoshi": 22.5,
            "shijihaoshi": null,
            "miaoShu": "<p>风格一致<br></p>",
            "jieZhi": "2021-03-24 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/737de1734c2a4b6db30d53fd3891ab4b.jpg", "name": "刘嘉瑜", "bumen": "已离职", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        },
        {
            "id": 610,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "精修",
            "createTime": "2021-02-01 10:51:06",
            "updateTime": "2021-02-01 10:51:06",
            "status": "正在进行",
            "title": "电脑护眼灯A+",
            "chuliId": 4,
            "fabuId": 16,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-03-29 11:00:00",
            "yujihaoshi": 22.5,
            "shijihaoshi": null,
            "miaoShu": "<p>1</p>",
            "jieZhi": "2021-04-01 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/f03d2c95a1e3487b89f991ee8fd82c73.jpg", "name": "黄导", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        }, {
            "id": 629,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "精修",
            "createTime": "2021-02-20 10:18:17",
            "updateTime": "2021-02-20 10:18:17",
            "status": "正在进行",
            "title": "太阳能泵A+需求",
            "chuliId": 4,
            "fabuId": 42,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-04-01 11:00:00",
            "yujihaoshi": 22.5,
            "shijihaoshi": null,
            "miaoShu": "<p>1</p>",
            "jieZhi": "2021-04-05 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/04053c0e17a541ac93c4f4fe3e5fe3a4.jpg", "name": "黄玮", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        }, {
            "id": 642,
            "leixing": "亚马逊 7张主图",
            "imgLeixing": "精修",
            "createTime": "2021-02-23 10:40:36",
            "updateTime": "2021-02-23 10:40:36",
            "status": "正在进行",
            "title": "运动手环图片需求 ",
            "chuliId": 4,
            "fabuId": 42,
            "kaifaId": 95,
            "wangpan": "1",
            "yujikaishi": "2021-04-05 11:00:00",
            "yujihaoshi": 15.0,
            "shijihaoshi": null,
            "miaoShu": "<p><font style=\"vertical-align: inherit;\"><font style=\"vertical-align: inherit;\">1个</font></font></p>",
            "jieZhi": "2021-04-07 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/04053c0e17a541ac93c4f4fe3e5fe3a4.jpg", "name": "黄玮", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": { "img": "/upload/5065e2109ed547ecbdc286a663880c73.jpg", "name": "罗开坤", "bumen": "产品部", "groups": null }
        }, {
            "id": 651,
            "leixing": "自定义",
            "imgLeixing": "精修",
            "createTime": "2021-02-25 15:17:54",
            "updateTime": "2021-02-25 15:17:54",
            "status": "正在进行",
            "title": "培育盒A+ ",
            "chuliId": 4,
            "fabuId": 42,
            "kaifaId": 110,
            "wangpan": "1",
            "yujikaishi": "2021-04-12 11:00:00",
            "yujihaoshi": 15.0,
            "shijihaoshi": null,
            "miaoShu": "<p>1</p>",
            "jieZhi": "2021-04-14 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/04053c0e17a541ac93c4f4fe3e5fe3a4.jpg", "name": "黄玮", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": { "img": "/upload/22c110383bdf44e181252832d4ad9f08.jpg", "name": "徐军", "bumen": "产品部", "groups": null }
        }, {
            "id": 610,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "精修",
            "createTime": "2021-02-01 10:51:06",
            "updateTime": "2021-02-01 10:51:06",
            "status": "正在进行",
            "title": "电脑护眼灯A+",
            "chuliId": 4,
            "fabuId": 16,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-03-29 11:00:00",
            "yujihaoshi": 22.5,
            "shijihaoshi": null,
            "miaoShu": "<p>1</p>",
            "jieZhi": "2021-04-01 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/f03d2c95a1e3487b89f991ee8fd82c73.jpg", "name": "黄导", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        }, {
            "id": 643,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "精修",
            "createTime": "2021-02-23 11:25:00",
            "updateTime": "2021-02-23 11:25:00",
            "status": "正在进行",
            "title": "太阳能喷泉泵A+需求",
            "chuliId": 4,
            "fabuId": 103,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-04-07 11:00:00",
            "yujihaoshi": 22.5,
            "shijihaoshi": null,
            "miaoShu": "<p>1<br></p>",
            "jieZhi": "2021-04-12 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/ff035f57182546f2b2b728c50d4c51ae.jpg", "name": "屈晓蝶", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        },
        {
            "id": 656,
            "leixing": "亚马逊 7张主图",
            "imgLeixing": "精修",
            "createTime": "2021-02-26 10:17:36",
            "updateTime": "2021-02-26 10:17:36",
            "status": "正在进行",
            "title": "玻璃吸管图片需求",
            "chuliId": 4,
            "fabuId": 103,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-04-27 11:00:00",
            "yujihaoshi": 15.0,
            "shijihaoshi": null,
            "miaoShu": "<p>1<br></p>",
            "jieZhi": "2021-04-29 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/ff035f57182546f2b2b728c50d4c51ae.jpg", "name": "屈晓蝶", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        }, {
            "id": 658,
            "leixing": "自定义",
            "imgLeixing": "精修",
            "createTime": "2021-02-26 10:20:51",
            "updateTime": "2021-02-26 10:20:51",
            "status": "正在进行",
            "title": "和弦工具图片需求",
            "chuliId": 4,
            "fabuId": 103,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-04-29 11:00:00",
            "yujihaoshi": 20.0,
            "shijihaoshi": null,
            "miaoShu": "<p>1<br></p>",
            "jieZhi": "2021-05-01 17:30:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/ff035f57182546f2b2b728c50d4c51ae.jpg", "name": "屈晓蝶", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        }, {
            "id": 661,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "细精修",
            "createTime": "2021-03-01 15:21:40",
            "updateTime": "2021-03-01 15:21:40",
            "status": "正在进行",
            "title": "冰格四件套主图和A+",
            "chuliId": 4,
            "fabuId": 117,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-05-01 17:30:00",
            "yujihaoshi": 30.0,
            "shijihaoshi": null,
            "miaoShu": "<p>.<br></p>",
            "jieZhi": "2021-05-06 17:30:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/466708a5ed7d4db2927876be44976d96.jpg", "name": "卢汝佳", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        }, {
            "id": 663,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "细精修",
            "createTime": "2021-03-02 10:43:58",
            "updateTime": "2021-03-02 10:43:58",
            "status": "正在进行",
            "title": "磨甲器黑色主图A+",
            "chuliId": 4,
            "fabuId": 112,
            "kaifaId": 110,
            "wangpan": "1",
            "yujikaishi": "2021-05-06 17:30:00",
            "yujihaoshi": 30.0,
            "shijihaoshi": null,
            "miaoShu": "<p>1<br></p>",
            "jieZhi": "2021-05-12 17:30:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/4a4f36d6257d4b298dff4cbb90cb7896.jpg", "name": "抬欢欢", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": { "img": "/upload/22c110383bdf44e181252832d4ad9f08.jpg", "name": "徐军", "bumen": "产品部", "groups": null }
        }, {
            "id": 664,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "细精修",
            "createTime": "2021-03-02 10:44:22",
            "updateTime": "2021-03-02 10:44:22",
            "status": "正在进行",
            "title": "磨甲器白色主图A+",
            "chuliId": 4,
            "fabuId": 112,
            "kaifaId": 110,
            "wangpan": "1",
            "yujikaishi": "2021-05-12 17:30:00",
            "yujihaoshi": 30.0,
            "shijihaoshi": null,
            "miaoShu": "<p>1<br></p>",
            "jieZhi": "2021-05-17 17:30:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/4a4f36d6257d4b298dff4cbb90cb7896.jpg", "name": "抬欢欢", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": { "img": "/upload/22c110383bdf44e181252832d4ad9f08.jpg", "name": "徐军", "bumen": "产品部", "groups": null }
        }, {
            "id": 666,
            "leixing": "图片修改",
            "imgLeixing": "精修",
            "createTime": "2021-03-02 14:09:23",
            "updateTime": "2021-03-02 14:09:23",
            "status": "正在进行",
            "title": "五张冷风机彩盒白底图",
            "chuliId": 4,
            "fabuId": 9,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-05-17 17:30:00",
            "yujihaoshi": 2.5,
            "shijihaoshi": null,
            "miaoShu": "<p>1</p>",
            "jieZhi": "2021-05-18 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/949a4259ba824d1b93e1448319e50614.jpg", "name": "陈英泽", "bumen": "大客户业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        }, {
            "id": 678,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "精修",
            "createTime": "2021-03-08 12:26:31",
            "updateTime": "2021-03-08 12:26:31",
            "status": "正在进行",
            "title": "咬胶蛋A+需求",
            "chuliId": 4,
            "fabuId": 42,
            "kaifaId": 95,
            "wangpan": "1",
            "yujikaishi": "2021-05-18 11:00:00",
            "yujihaoshi": 22.5,
            "shijihaoshi": null,
            "miaoShu": "<p>1</p>",
            "jieZhi": "2021-05-21 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/04053c0e17a541ac93c4f4fe3e5fe3a4.jpg", "name": "黄玮", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": { "img": "/upload/5065e2109ed547ecbdc286a663880c73.jpg", "name": "罗开坤", "bumen": "产品部", "groups": null }
        }, {
            "id": 689,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "细精修",
            "createTime": "2021-03-10 12:04:29",
            "updateTime": "2021-03-10 12:04:29",
            "status": "正在进行",
            "title": "无盖储物盒主图和A+",
            "chuliId": 4,
            "fabuId": 117,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-05-21 11:00:00",
            "yujihaoshi": 30.0,
            "shijihaoshi": null,
            "miaoShu": "<p>1<br></p>",
            "jieZhi": "2021-05-27 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/466708a5ed7d4db2927876be44976d96.jpg", "name": "卢汝佳", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        }, {
            "id": 690,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "细精修",
            "createTime": "2021-03-10 12:05:08",
            "updateTime": "2021-03-10 12:05:08",
            "status": "正在进行",
            "title": "脏衣篓主图和A+",
            "chuliId": 4,
            "fabuId": 117,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-05-27 11:00:00",
            "yujihaoshi": 30.0,
            "shijihaoshi": null,
            "miaoShu": "<p>1<br></p>",
            "jieZhi": "2021-06-01 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/466708a5ed7d4db2927876be44976d96.jpg", "name": "卢汝佳", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        }, {
            "id": 691,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "细精修",
            "createTime": "2021-03-10 12:05:51",
            "updateTime": "2021-03-10 12:05:51",
            "status": "正在进行",
            "title": "桌面编织收纳盒主图和A+",
            "chuliId": 4,
            "fabuId": 117,
            "kaifaId": null,
            "wangpan": "1",
            "yujikaishi": "2021-06-01 11:00:00",
            "yujihaoshi": 30.0,
            "shijihaoshi": null,
            "miaoShu": "<p>1<br></p>",
            "jieZhi": "2021-06-07 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/466708a5ed7d4db2927876be44976d96.jpg", "name": "卢汝佳", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": null
        }, {
            "id": 693,
            "leixing": "亚马逊 7张主图+A+",
            "imgLeixing": "精修",
            "createTime": "2021-03-10 17:29:29",
            "updateTime": "2021-03-10 17:29:29",
            "status": "已完成",
            "title": "工具套装 主图A+需求 ",
            "chuliId": 4,
            "fabuId": 29,
            "kaifaId": 97,
            "wangpan": "1",
            "yujikaishi": "2021-06-07 11:00:00",
            "yujihaoshi": 22.5,
            "shijihaoshi": null,
            "miaoShu": "<p>详见表格<br></p>",
            "jieZhi": "2021-06-10 11:00:00",
            "isGraded": false,
            "gradeQuality": 0,
            "gradeChat": 0,
            "gradeSpeed": 0,
            "doneTime": null,
            "queueType": "先来后到",
            "countImg": null,
            "fabu": { "img": "/upload/1940a1c4ca0b463c8a626ff7842a1eac.jpg", "name": "姚田", "bumen": "消费者业务部", "groups": null },
            "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
            "kaifa": { "img": "/upload/40242d43b0744bd3a391778e94a617d2.jpg", "name": "张宇", "bumen": "产品部", "groups": null }
        }
    ]
    // data: [{
    //     "id": 664,
    //     "leixing": "亚马逊 7张主图+A+",
    //     "imgLeixing": "细精修",
    //     "createTime": "2021-03-02 10:44:22",
    //     "updateTime": "2021-03-02 10:44:22",
    //     "status": "正在进行",
    //     "title": "磨甲器白色主图A+",
    //     "chuliId": 4,
    //     "fabuId": 112,
    //     "kaifaId": 110,
    //     "wangpan": "1",
    //     "yujikaishi": "2021-05-12 17:30:00",
    //     "yujihaoshi": 30.0,
    //     "shijihaoshi": null,
    //     "miaoShu": "<p>1<br></p>",
    //     "jieZhi": "2021-05-17 17:30:00",
    //     "isGraded": false,
    //     "gradeQuality": 0,
    //     "gradeChat": 0,
    //     "gradeSpeed": 0,
    //     "doneTime": null,
    //     "queueType": "先来后到",
    //     "countImg": null,
    //     "fabu": { "img": "/upload/4a4f36d6257d4b298dff4cbb90cb7896.jpg", "name": "抬欢欢", "bumen": "消费者业务部", "groups": null },
    //     "chuli": { "img": "/upload/68067f3e40b6434f8ae8ad3c5c525501.jpg", "name": "吕伟团", "bumen": "设计师", "groups": null },
    //     "kaifa": { "img": "/upload/22c110383bdf44e181252832d4ad9f08.jpg", "name": "徐军", "bumen": "产品部", "groups": null }
    // }]
}

let res = Array.from(TaskData.data, item => {
    return {
        title: item.title,
        startTime: item.yujikaishi && new Date(item.yujikaishi) || undefined,
        duration: item.yujihaoshi,
        endTime: item.jieZhi && new Date(item.jieZhi) || undefined,
        class: item.status === '已完成' ? 'suc' : 'default'
    }
})
export default res
